"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserClient = void 0;

var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");

var _constants = require("../constants");

var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");

var _cookie = require("@tajawal/web-core-sdk-v2/lib/services/cookie.service");

var token = _cookie.$cookie.get('token');

token && _http.$http.addHeaders({
  Authorization: "Bearer ".concat(_cookie.$cookie.get('token'))
});
var UserClient = {
  profile: function profile() {
    var requestId = 'ME';
    var endPoint = _constants.ENDPOINTS.ME;
    return _http.$http.get(requestId, endPoint).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  },
  updateProfile: function updateProfile(userId, user) {
    var requestId = 'UPDATE_USER';
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.USER, {
      userId: userId
    });
    return _http.$http.put(requestId, endPoint, {
      data: user
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  submitPromo: function submitPromo(payload) {
    var requestId = 'SUBMIT_PROMO';
    return _http.$http.post(requestId, _constants.ENDPOINTS.SUBMIT_PROMO, {
      data: payload
    }).then(function (_ref3) {
      var data = _ref3.data;
      return data;
    });
  },
  claimUserPoints: function claimUserPoints() {
    var requestId = 'USER_LINK_ORDER';
    var endPoint = _constants.ENDPOINTS.USER_LINK_ORDER;
    return _http.$http.post(requestId, endPoint, {}).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  deleteAccount: function deleteAccount(payload) {
    var requestId = 'DELETE_ACCOUNT';
    return _http.$http.post(requestId, _constants.ENDPOINTS.DELETE_ACCOUNT, {
      data: payload
    }).then(function (_ref5) {
      var data = _ref5.data;
      return data;
    });
  }
};
exports.UserClient = UserClient;